// extracted by mini-css-extract-plugin
module.exports = {"grid":"archive-module--grid--12nQ-","item":"archive-module--item--3Mf5R","titleCard":"archive-module--titleCard--3gN6v","background":"archive-module--background--2vQhv"};